let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jdeAV"), load("7jwEY"), load("5LCFM")]).then(() => parcelRequire('huNwZ'));